import React from "react";
import { Row, Col } from 'react-bootstrap';
import QuestionSection from "./QuestionSection";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux'
import * as FormActionCreator from "../../../redux/creators/form";
import { translate } from "../../base/Translation";

class QuestionSections extends React.Component {

	addSection() {

		this.props.addSection({
			id: -Math.random(),
			name: "",
			note: "",
			weight: 0,
			question_groups: []
		});

	}

	render() {

		console.log(this.props.form.question_sections);

		let sections = this.props.form.question_sections.map((section, index) => {
			return (<QuestionSection key={section.id} section={section} updateSection={this.props.updateSection} />)
		});

		return (
			<Row>
				<Col lg={12}>
					{sections}
				</Col>
				<Col lg={12}>
					<button className="btn btn-primary btn-sm" onClick={this.addSection.bind(this)}>{translate("Pridať sekciu")}</button>
				</Col>
			</Row>
		)
	}

}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({ addSection: FormActionCreator.addSectionAction, updateSection: FormActionCreator.updateSectionAction }, dispatch);
}

export default connect(state => ({ form: state.form }), matchDispatchToProps)(QuestionSections);


// WEBPACK FOOTER //
// ./src/modules/form/edit/QuestionSections.js